module.exports = __webpack_public_path__ + "img/coach_lock_grey.e6a62d00.svg";